import type { DeviceAccess } from './deviceProbe'

export function micBannerVisible({
  isGhost,
  micIntended,
  hasMicPublication,
  micAccess,
  dismissedAccess,
}: {
  isGhost: boolean
  micIntended: boolean
  hasMicPublication: boolean
  micAccess: DeviceAccess | null
  dismissedAccess: DeviceAccess | null
}): boolean {
  return (
    !isGhost &&
    micIntended &&
    !hasMicPublication &&
    Boolean(micAccess && ['blocked', 'missing', 'busy', 'silent'].includes(micAccess)) &&
    micAccess !== dismissedAccess
  )
}
